const CalcUtils = {
    /**
     * 加法运算
     */
    add() {
        let args = arguments;
        let first = args[0];

        // 浮点数加法运算
        let floatAdd = function(arg1, arg2) {
            let r1, r2, m, n;
            try {
                r1 = arg1.toString().split('.')[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = arg2.toString().split('.')[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            // 动态控制精度长度
            n = r1 >= r2 ? r1 : r2;
            return parseFloat(((arg1 * m + arg2 * m) / m).toFixed(n));
        };

        for (let i = 1; i < arguments.length; i++) {
            first = floatAdd(first, args[i]);
        }
        return first;
    },

    /**
     * 减法
     */
    sub() {
        let args = arguments;
        let first = args[0];

        // 浮点数减法
        let floatSub = function(arg1, arg2) {
            let r1, r2, m, n;
            try {
                r1 = arg1.toString().split('.')[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = arg2.toString().split('.')[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            // 动态控制精度长度
            n = r1 >= r2 ? r1 : r2;
            return parseFloat(((arg1 * m - arg2 * m) / m).toFixed(n));
        };

        for (var i = 1; i < arguments.length; i++) {
            first = floatSub(first, args[i]);
        }
        return first;
    },

    /**
     * 浮点数乘法
     * @param {*} arg1
     * @param {*} arg2
     */
    multi(arg1, arg2) {
        let m = 0;
        let s1 = arg1.toString();
        let s2 = arg2.toString();
        try {
            m += s1.split('.')[1].length;
        } catch (e) {
            console.log(e);
        }
        try {
            m += s2.split('.')[1].length;
        } catch (e) {
            console.log(e);
        }
        return (
            (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
            Math.pow(10, m)
        );
    },

    /**
     * 浮点数除法
     * @param {*} arg1
     * @param {*} arg2
     */
    division(arg1, arg2) {
        let t1 = 0;
        let t2 = 0;
        let r1;
        let r2;
        try {
            t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
            console.log(e);
        }
        try {
            t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
            console.log(e);
        }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return (r1 / r2) * Math.pow(10, t2 - t1);
    }
};
export default CalcUtils;
